import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { mode: String, open: Boolean }

  connect() {
    // 서버사이드에서 이미 소진 상태이면 즉시 표시
    if (this.openValue) {
      this.showBlockModal()
    }

    // 잠긴 모델 클릭 시 업그레이드 모달 오픈
    if (!window.__upgradeRequiredListenerAdded) {
      window.__upgradeRequiredListenerAdded = true
      window.addEventListener('klavy:upgrade-required', (e) => this.showBlockModal(e.detail?.reason))
    }

    // 402 응답 인터셉트를 위한 전역 fetch 패치
    if (!window.__upgradeNudgePatched) {
      window.__upgradeNudgePatched = true
      const originalFetch = window.fetch
      window.fetch = async (...args) => {
        const response = await originalFetch(...args)
        if (response.status === 402) {
          const clone = response.clone()
          clone.json().then(data => {
            if (data.error === "quota_exceeded") {
              this.showBlockModal(data.reason)
            }
          }).catch(() => {})
        }
        return response
      }
    }
  }

  close() {
    this.element.classList.add("upgrade-nudge--hidden")
    this.element.style.display = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) this.close()
  }

  showBlockModal(reason) {
    const title    = this.element.querySelector('.upgrade-nudge__title')
    const body     = this.element.querySelector('.upgrade-nudge__body')
    const usageBtn = this.element.querySelector('.upgrade-nudge__btn-usage')

    if (reason === 'credit_pack_insufficient') {
      if (title) title.textContent = '생성 포인트가 부족해요'
      if (body)  body.textContent  = '선택한 모델을 실행하려면 차감 P만큼 생성 포인트가 필요해요. 생성 포인트를 충전하거나 다른 모델을 선택해주세요.'
      if (usageBtn) usageBtn.style.display = ''
    } else if (reason === 'model_not_available') {
      if (title) title.textContent = '유료 플랜 전용 모델이에요'
      if (body)  body.textContent  = '이 AI 모델은 유료 플랜에서만 사용할 수 있어요. 요금제를 업그레이드하면 바로 선택할 수 있어요.'
      if (usageBtn) usageBtn.style.display = 'none'
    } else {
      if (title) title.textContent = '오늘 AI 사용량을 다 썼어요'
      if (body)  body.innerHTML   = '매일 자정(00:00 KST)에 초기화돼요.<br>지금 바로 더 쓰고 싶다면 요금제를 업그레이드해보세요.'
      if (usageBtn) usageBtn.style.display = ''
    }

    this.element.classList.remove("upgrade-nudge--toast")
    this.element.classList.remove("upgrade-nudge--hidden")
    this.element.classList.add("upgrade-nudge--block")
    this.element.style.display = "flex"
    this.modeValue = "block"
  }
}
